import React from 'react';

export const NewPaymentContext = React.createContext();
const { Provider: NewProvider } = NewPaymentContext;
export { NewProvider as NewPaymentProvider };
